<template>
    <div class="crop" :style="{height: height + 'px', width: width + 'px', overflow: 'hidden'}">
        <img :src="img" alt="Image missing" :style="{height: 'auto', width: width + 'px'}"/>
    </div>
</template>

<script>
  export default {
    name: 'BImg',

    props: {
      img: '',
      width: '',
      height: '',
    },
  }
</script>

<style scoped>

</style>
